var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewchatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.414H2.083A1.333 1.333 0 0 0 .75 2.748v9.333a1.333 1.333 0 0 0 1.333 1.333h9.334a1.334 1.334 0 0 0 1.333-1.333V7.414M11 1.164a1.414 1.414 0 1 1 2 2l-6.009 6.01a1.3 1.3 0 0 1-.568.336l-1.916.56a.334.334 0 0 1-.413-.413l.56-1.915c.063-.215.18-.41.337-.568z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewchatIcon);
export default __webpack_public_path__ + "static/media/newchat_icon.5a5b654fecf1f14df82b146576952e26.svg";
export { ForwardRef as ReactComponent };